export default function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/es/utils/capitalize.js
// module id = ./node_modules/react-bootstrap/es/utils/capitalize.js
// module chunks = 2